// Kontingent-Grants (CUR-523) — Spec: docs/features/tutor-kontingent-grants.md

export interface QuotaGrant {
  id: string;
  userId: string;
  feature: string;
  amount: number;
  consumed: number;
  remaining: number;
  validFrom: string;
  validUntil: string;
  campaign: string | null;
  reason: string;
  grantedBy: string;
  revokedAt: string | null;
  createdAt: string;
}

export interface UserQuotaGrants {
  bonusRemaining: number;
  bonusExpiresAt: string | null;
  grants: QuotaGrant[];
}

export interface CampaignRow {
  campaign: string;
  users: number;
  grantedUnits: number;
  consumedUnits: number;
  estimatedCostCents: { min: number; max: number };
}

export interface GrantQuotaPayload {
  userIds: string[];
  feature: 'tutor';
  amount: number;
  validUntil: string;
  campaign?: string;
  reason: string;
}

/** Gemessene Stückkosten je Nachricht in Cent (Spec §6, Backend-Spiegel in
 *  quotaGrants.service.ts). Premium fährt Haiku, Premium+ Sonnet — eine Aktion
 *  kann beide treffen, deshalb zeigt die UI eine Spanne statt einer
 *  Scheingenauigkeit. */
export const UNIT_COST_CENTS = { haiku: 0.95, sonnet: 3.01 } as const;

export function estimateCostEur(units: number): { min: number; max: number } {
  return {
    min: (units * UNIT_COST_CENTS.haiku) / 100,
    max: (units * UNIT_COST_CENTS.sonnet) / 100,
  };
}
